import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import PageValidator from '../../validators/PageValidator'
import InputField from '../Inputs/InputField'
import {sections} from '../../utils/variables'
class PageForm extends Component {

    constructor(props) {
	super(props);
	this.state = {
	    waiting: false
	}
    }
    
    
    componentDidMount(){


    }
    
    render() {
	const { handleSubmit, successAction } = this.props

	let {waiting} = this.state
	
	const submit = (values, dispatch, props) => {
	    let errors = PageValidator( values, props ) || {};
	    waiting=true
	    this.setState({waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {

		let saveAction = values.id ? props.updatePage : props.savePage
		
		saveAction(values).then((res) => {
		    props.reset()
		    successAction()
		    waiting=false
		    this.setState({waiting})
		}).catch((err) => {console.log(err)

		    waiting=false
		    this.setState({waiting})
		})
	    }
	}

	
	return (

	    <form onSubmit={handleSubmit(submit)}>
		<InputField name="title" type="text" label="Naslov" />
		<InputField name="section" type="select" options={[{value: '', name: 'Zberi'}].concat(sections.map((s) => ({value: s, name: s})))} label="Sekcija od menuja" />
		<InputField name="description" type="textarea" label="Opis" />

		<button type="submit" disabled={this.props.invalid || waiting} className="btn btn-brown btn-big full-width" >
		    <i style={{display: (waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i>
		    {
			this.props.invalid ?
			'Pomankljivosti v unosu podtkov poglej zgoraj'
			:
			'Shrani'
		    }
		</button>
	    </form>
	);
    }
}

export default reduxForm({
    form: 'page',
    validate: PageValidator,
    enableReinitialize: true
})(PageForm);



// WEBPACK FOOTER //
// ./src/components/PagesForm/index.jsx